import React from 'react';

const GitlabIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 380 380"
    fill="#000000"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Gitlab tanuki/fox logo */}
    <path d="M190 353.9L258.4 143.8H121.6L190 353.9z" />
    <path d="M190 353.9L121.6 143.8H30.6L190 353.9z" />
    <path d="M30.6 143.8L6.7 217.4c-2.2 6.7.2 14.1 5.9 18.2L190 353.9 30.6 143.8z" />
    <path d="M30.6 143.8H121.6L82.8 24.5c-2.4-7.4-13-7.4-15.4 0L30.6 143.8z" />
    <path d="M190 353.9L258.4 143.8H349.4L190 353.9z" />
    <path d="M349.4 143.8L373.3 217.4c2.2 6.7-.2 14.1-5.9 18.2L190 353.9 349.4 143.8z" />
    <path d="M349.4 143.8H258.4L297.2 24.5c2.4-7.4 13-7.4 15.4 0L349.4 143.8z" />
  </svg>
);

export default GitlabIcon;
